// extracted by mini-css-extract-plugin
export default {"BlocEmail":"BlocEmail_BlocEmail__7qBvx"};